module.exports = __webpack_public_path__ + "img/2-2.96f6a817.png";